<div class="wrapper">
    <p class="font-weight-bold title">
        Preisberechnung
    </p>
    <p class="text-muted sub-title">
        Hier werden die Fehler dargestellt, welche beim Berechnen der Preise aufgetreten sind.
    </p>
    <div class="card">
        <div class="card-body">
            <app-table-header
                    [(pageIndex)]="calculatorMessagesService.pageIndex"
                    [pageCount]="calculatorMessagesService.data?.pageCount"
                    [error]="calculatorMessagesService.error"
                    [loading]="calculatorMessagesService.loading"
                    [(filter)]="calculatorMessagesService.filter"
                    filterPlaceholder="Modellnummer Intern"
                    (reload)="calculatorMessagesService.fetch()"
            >
            </app-table-header>
            <ng-container *ngIf="calculatorMessagesService.data != null">
                <table class="table table-striped">
                    <thead>
                    <tr>
                        <th>
                            <p>Modellnummer Intern</p>
                        </th>
                        <th>
                            <p>Meldung</p>
                        </th>
                        <th>
                            <p>Zielfeld</p>
                        </th>
                        <th>
                            <p>Fehlender Produktwert</p>
                        </th>
                        <th>
                            <p>Fehlender Backendwert</p>
                        </th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr *ngFor="let error of calculatorMessagesService.data.calculatorMessages">
                        <td>
                            <p>
                                <a [href]="'/api/products/' + error.productId">
                                    {{error.modellnummerIntern}}
                                </a>
                            </p>
                        </td>
                        <td>
                            <p>{{error.message}}</p>
                        </td>
                        <td>
                            <p>{{error.targetValue}}</p>
                        </td>
                        <td>
                            <p>{{error.missingProductValue}}</p>
                        </td>
                        <td>
                            <p>{{error.missingBackendValue}}</p>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </ng-container>
        </div>
    </div>
</div>
